<template>
    <div class="row EditRowDiv" style="height:70px;" v-if="CheckPermission(Permission)">
        <div class="col padding-top-md EditDiv" style="position:fixed;bottom:40px;z-index:999;pointer-events:none;">
            <div class="pointer" style="width:fit-content;pointer-events:auto;" v-on:click="ToggleEditMode()">
                <b-button variant="olive-green" v-if="EditMode"> <font-awesome-icon :icon="['fa', 'edit']" /> Edit Mode: ON</b-button>
                <b-button variant="olive-yellow" v-else> <font-awesome-icon :icon="['fa', 'edit']" /> Edit Mode: OFF</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    export default {
        props: [
            'Permission',
            'EditMode'
        ],
        methods: {
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
                this.$emit("update-edit-mode");
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            mounted() {
                console.log(Permission);
            }
        }
    }
</script>

<style scoped>
    /*.btn-default, 
    .btn-default:hover, 
    .btn-default:active, 
    .btn-default:active:focus, 
    .btn-default:visited, 
    .btn-default:focus,
    .btn-secondary, 
    .btn-secondary:hover, 
    .btn-secondary:active, 
    .btn-secondary:active:focus, 
    .btn-secondary:visited, 
    .btn-secondary:focus 
    {     color: #dcdcdc;     
          background-color: #232323;       
          outline: none; 

    }*/
    .btn-olive-green {
        background-color: #94A545 !important;
        color: white;
        box-shadow:none;
    }
    .btn-olive-yellow {
        background-color: #EFB22D !important;
        color: black;
        box-shadow:none;
    }
</style>